(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-hub"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-etg-faq]').forEach((root) => {
    const search = root.querySelector('[data-faq-search]');
    const empty = root.querySelector('[data-faq-empty]');
    if (!search) return;
    search.addEventListener('input', () => {
      const query = search.value.trim().toLocaleLowerCase();
      let matches = 0;
      root.querySelectorAll('[data-faq-item]').forEach((item) => {
        const visible = !query || item.textContent.toLocaleLowerCase().includes(query);
        item.hidden = !visible;
        if (visible) matches += 1;
      });
      root.querySelectorAll('[data-faq-group]').forEach((group) => {
        group.hidden = !Array.from(group.querySelectorAll('[data-faq-item]')).some((item) => !item.hidden);
      });
      empty.hidden = matches > 0;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
